import { SEARCH_SUGGESTIONS } from './actions';
import getIn from '@alexaivars/get-in';

const suggestions = (state = {}, action = {}) => {
  switch (action.type) {
    case `${SEARCH_SUGGESTIONS}_SUCCESS`:
      return { ...action.payload.body };
    default:
      return state;
  }
};

export const getTopics = state =>
  getIn(state, ['searchTool', 'data', 'attributes', 'topics'], []);

export const getRegions = state =>
  getIn(state, ['searchTool', 'data', 'attributes', 'regions'], []);

export const getTopicsLabelsForIds = (state, topicIds) => {
  const topics = getTopics(state);
  let topicLabels = [];
  const topicIdsArray = topicIds.split(' ').filter(n => n);
  topics.forEach(function(topic) {
    if (topicIdsArray.indexOf(topic.id) !== -1) {
      topicLabels.push({ label: topic.label, id: topic.id });
    }
  });

  return topicLabels;
};

export const getRegionsLabelsForIds = (state, regionIds) => {
  const regions = getRegions(state);
  let regionsLabels = [];
  const regionIdsArray = regionIds.split(' ').filter(n => n);

  regions.forEach(function(region) {
    if (regionIdsArray.indexOf(region.id) !== -1) {
      regionsLabels.push({ label: region.label, id: region.id });
    }
  });

  return regionsLabels;
};

export default suggestions;
